import { Box, Button, Group, Text } from "@mantine/core";
import { BBox } from "components";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ItemsTable } from "./components";

export const Items = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <BBox
      header={
        <Group position="apart">
          <Text size="sm" weight={500}>
            {t("ITEMS_LIST")}
          </Text>
          <Button onClick={() => navigate("new")}>{t("ADD_NEW")}</Button>
        </Group>
      }
    >
      <Box p="xl">
        <ItemsTable />
      </Box>
    </BBox>
  );
};
